$(function () {
    //IE11 Detection
    var IE11 = !!(navigator.userAgent.match(/Trident/) && navigator.userAgent.match(/rv[ :]11/));;
    if (IE11 === true) {
        $('html').addClass('IE11');
    }

    const $tabLinksWrap = $('#tabs > .tab-links');
    const $tabFirstBtn = $tabLinksWrap.find('button').eq(0);
  
    $("#tabs > div").hide();
    $("#tabs > div:first").show();
    $tabFirstBtn.addClass('active');
    
    $tabLinksWrap.on('click', 'button', function () {
      const $this = $(this);
      const $sibling = $this.siblings();
  
      $sibling.removeClass('active').attr({
        'tabindex': '-1',
        'aria-selected': 'false'
      });
  
      $this.addClass('active').attr({
        'tabindex': '0',
        'aria-selected': 'true'
      });
  
      var currentTab = $this.attr('aria-controls');
      $("#tabs > div").hide();
      $(`#${currentTab}`).show();
  
      return false;
    });
    $(window).on("load", function () {
        $('.item-image, .slider').flexslider({
            animation: "slide",
            animationLoop: false,
            useCSS: false
        });
    });
    if (document.body.classList.contains("pghome")) {
        function checkWidth() {
            var viewportWidth = document.documentElement.clientWidth;
            if (viewportWidth < 768) {

            } else {

            }
        }
        checkWidth();
        window.addEventListener("resize", function () {
            checkWidth();
        });
    }
    
});
//Moved Swiper code here because swiper.js file was creating new elements after scroll-animation.js file had already checked all elements on the DOM
//causing a bug where the duplicated elements generated by Swiper weren't catched by AOS and appeared with opacity 0
//IE11 swiper js 'startsWith' Polyfill
if (!String.prototype.startsWith) {
    String.prototype.startsWith = function(searchString, position){
    position = position || 0;
    return this.substr(position, searchString.length) === searchString;
};
}
var swiper = new Swiper('.product-bottom .swiper-container', {
    slidesPerView: 2,
    spaceBetween: 1,
    loop: false,
    a11y: {
        enabled: true,
        slideLabelMessage: ""
    },
    navigation: {
    nextEl: '.swiper-button-next',
    prevEl: '.swiper-button-prev',
    },
    breakpoints: {
    768: {
        slidesPerView: 3,
        spaceBetween: 20,
    },
    }
});


var swiper = new Swiper('.item-image .swiper-container', {
    slidesPerView: 1,
    spaceBetween: 0,
    watchOverflow:true,
    a11y: {
        enabled: true,
        slideLabelMessage: ""
    },
    navigation: {
    nextEl: '.swiper-button-next',
    prevEl: '.swiper-button-prev',
    }
});

$(function () {
    var $dropdowns = $("#main-nav .dropdown");
    var $dropdownsLinks = $("#main-nav .dropdownLink");
    let isMobile = window.matchMedia("(max-width: 1024px)").matches;
    $dropdownsLinks.on("focus",function(){
      let $thisParent = $(this).parent();
      $dropdowns.removeClass("open");
      $dropdownsLinks.attr("aria-expanded", "undefined");
      $thisParent.addClass("open");
      if (!isMobile) {
        $(this).attr("aria-expanded", "true");
      }
    })

    let fitstNavChild = $("#main-nav [role=menuitem]").first()[0];
    $(fitstNavChild).on("keydown", function(e) {
      if(e.key === 'Tab' && e.shiftKey) {
        $dropdowns.removeClass("open");
        $dropdownsLinks.attr("aria-expanded", "false");
      }
    })

    let lastNavChild = $("#main-nav [role=menuitem]").last()[0];
    $(lastNavChild).on("keydown", function(e) {
      if(e.key === 'Tab') {
        $dropdowns.removeClass("open");
        $dropdownsLinks.attr("aria-expanded", "false");
      }
    })
}); 
